import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NGX_SELECT_OPTIONS, NgxSelectModule } from 'ngx-select-ex';

import { IAtxSelectConfig } from './interfaces';
import { AtxSelectComponent, AtxSelectFormlyComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
        NgxSelectModule,
    ],
    declarations: [
        AtxSelectComponent,
        AtxSelectFormlyComponent,
    ],
    exports: [
        AtxSelectComponent,
    ],
})

export class AtxSelectModule {
    public static forRoot(options: IAtxSelectConfig): ModuleWithProviders {
        return {
            ngModule: AtxSelectModule,
            providers: [{
                provide: NGX_SELECT_OPTIONS,
                useValue: options
            }],
        }
    }
}
